import styled from "styled-components";
export const ReturnsWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
